import React from 'react';
import { GlobalStyles } from './components/';
import { ARMprovider } from './utils/context/context';
import Navigation from './utils/navigation/navigation';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './utils/helpers/queryClient';

function App() {
  return (
    <ARMprovider>
      <QueryClientProvider client={queryClient}>
        <GlobalStyles />
        <BrowserRouter>
          <Navigation />
        </BrowserRouter>
      </QueryClientProvider>
    </ARMprovider>
  );
}

export default App;
